

import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import contentfolder from "../../../../contentImgs/folder.png";
import LoadingButton from "../../../../Loading/LoadingButton";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,Timer,AudioLines,
    FolderHeart, Forward,Earth,ListChecks,Gift,Settings,BetweenHorizontalStart,
    ImagePlay,Film,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,ChevronUp,ChevronDown,
    GripHorizontal,
    CopyPlus,
    Bookmark,
    Pencil,
    Trash2,
    Recycle} from 'lucide-react';
import Checkbox from "../../../../UI/Checkbox";
import { addFolderToListAPI, createNewList, getAllListsByApp } from "../../../../../store/actions/CreateContent/FolderAPI/ListAPIs";
import Snackbar from "../../../../../Snackbar";
import Loading from "../../../../Loading/Loading";
    

const BookmarkListPopUp =({loadingText,folderItem,title,type ,onClickPopup,closePopUp})=>{

       const dispatch = useDispatch();
          
             const [snackbarVisible, setSnackbarVisible] = useState(false);
             const [snackbarColor, setSnackbarColor] = useState("#958FDA");
             const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
           
           const showSnackbar = () => {
             setSnackbarVisible(true);
           };
          
           const hideSnackbar = () => {
             setSnackbarVisible(false);
           };
     
     
          
           const [listName ,setListName] =useState("");
           const [newListPopUp ,setNewListPopUp] =useState(false);
                  const [ListID ,setListID] =useState();
                  const [folderMenuOrder ,setFolderMenuOrder] =useState();
                  const [showAddFolderEdit ,setShowAddFolderEdit] =useState()
                   const [showAddFolderDetails ,setShowAddFolderDetails] =useState()
                   
                    
          const [FolderLook ,setFolderLook] =useState("")
                
                
           
            const [animate, setAnimate] = useState(false);
      
                  const [loader , setLoader] =useState({status:false});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
         const [active , setActive] = useState({status:false});



 const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app[0]?.AppToken);
     
       useEffect(() => {
         // Trigger the animation after a delay (e.g., 500ms)
         const timer = setTimeout(() => {
          setAnimate(true);  
        }, 100);
      
         return () => clearTimeout(timer); // Cleanup on unmount
       }, []);

      useEffect(()=>{
        // setCourseTitleData();
      },[])
 const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [deleteFolderPopUp, setDeleteFolderPopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{}]);
           
           const [openPopUp ,setOpenPopUp]  = useState(false)
;  const [folders ,setFolders]  = useState([])
;
       const updateItemTitle = (ID, newTitle) => {
        const updatedItems = itemArr.map(item =>
          item?.ID === ID ? { ...item, Name :newTitle } : item
        
        ); 
      
       // console.log(updatedItems)
        setItemArr(updatedItems);
      };
      const setCheckedStatusOfList = (ID, checkedStatus) => {
        const updatedItems = itemArr.map(item =>
          item?.ID === ID ? { ...item, checkedStatus :checkedStatus } : item
        
        ); 
      
        
       // console.log(updatedItems)
        setItemArr(updatedItems);
      };
      const addListTOArray = (list) => {
        const updatedItems = [...itemArr, list]
        const updatedItemsMenuorder = [...itemReorderArr, {ID:list?.ID,menuOrder:list?.menuOrder}]
        setItemReorderArr( updatedItemsMenuorder);
       // console.log(updatedItems)
        setItemArr(updatedItems);
      };
      
       useEffect((e)=>{
         
       fireGetAllListsByApp()
          
           },[visibility]);
           const fireGetAllListsByApp=()=>{
             setItemArr([])
                   
           
                   
           
             setItemArrLoading([{},{},{}])
          
           setLoader({status:true});
              
                 const apiData = dispatch(getAllListsByApp({
                   token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                   appToken:AppToken,visibility:visibility,orderBy:orderBy
                   }));
                 /* get response as Promise   */
                 apiData.then(response => {
                  
           
                   if(response){
                    
                     if(response){
                   setResponseMessage(response?.message);
                   setSnackbarColor("rgba(144, 202, 249,1)");
                 
                   if(response?.bookmarkLists)  {
                    setItemArr(response?.bookmarkLists); 
           
                     const reorderArray = response?.bookmarkLists.map(item => ({
                       ID: item.ID,
                       menuOrder: item.menuOrder
                   }));
                   setItemReorderArr(reorderArray);
                  
                   getAllListByFolderID(response?.bookmarkLists)
                   }else{};
                   setItemArrLoading([]);
               setLoader({status:false});
               
               // setSnackbarVisible(true);
               setTimeout(()=>{
                 
                 setSnackbarVisible(false);
               },1000)
                  }else{
                 setSnackbarVisible(true);
               setTimeout(()=>{
                 
                 setSnackbarVisible(false);
                
                  
               },3000)
                  }
                     
                   
                  if(response?.logout){
                  
                   setResponseMessage("You are Logged Out!!!");
                     
                   setSnackbarColor("#958FDA");
                 
                    
               setLoader({status:false});
               
               setSnackbarVisible(true);
               setTimeout(()=>{
                 
                 setSnackbarVisible(false);
                
                  
               },3000)
                   setTimeout(()=>{
                     dispatch({type:"LOGOUT"});
               
                   },3000)
                   
                 }
               
                   }else{
                     setResponseMessage("Something Went Wrong...");
                     
                     setSnackbarColor("#958FDA");
                     setItemArrLoading([{},{},{}]);
                      
                 setLoader({status:false});
                 
                 setSnackbarVisible(true);
                 setTimeout(()=>{
                   
                   setSnackbarVisible(false);
                  
                    
                 },3000)    }
               
                 }).catch(error => {
                
                   //popup of error Info
                   setResponseMessage("Something Went Wrong...");
                     
                   setSnackbarColor("#958FDA");
                   
                    
               setLoader({status:false});
               
               setSnackbarVisible(true);
               setTimeout(()=>{
                 
                 setSnackbarVisible(false);
                
                  
               },3000)
                   console.error(error);
                 });
            }   
const handleCreateList=(e)=>{



setLoader({status:true});
// console.log({Name:folderName,
//     token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:"",
//     currentToken:currentToken?currentToken:"",appToken:AppToken,
//     editType:'',postId:ListID,menuOrder:folderMenuOrder})
  const apiData = dispatch(createNewList({Name:listName,
    token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:"",
    currentToken:currentToken?currentToken:"",appToken:AppToken,
    editType:ListID?"Name":"",postId:ListID?ListID:"",menuOrder:(itemArr?.length+1)}));
  /* get response as Promise   */
  apiData.then(response => {
    if(response){

       console.log(response)
      if(response?.BookmarkList){
    setResponseMessage(response?.message);
    setSnackbarColor("rgba(144, 202, 249,1)");
  
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
  
  // console.log(response?.BookmarkList)
  addListTOArray(response?.BookmarkList)
  
  setNewListPopUp(false);
  setListName("");
  setListID("");
  setFolderMenuOrder("")

},1000)
   }else{
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
    
   if(response?.logout){
   
    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }
/* resetting Login input Fields */

    }else{
      setResponseMessage("Something Went Wrong...");
      
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
 
  }


  const handleUpdateList=(e)=>{



    setLoader({status:true});
    // console.log({Name:folderName,
    //     token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:"",
    //     currentToken:currentToken?currentToken:"",appToken:AppToken,
    //     editType:'',postId:ListID,menuOrder:folderMenuOrder})
      const apiData = dispatch(createNewList({Name:listName,
        token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",appToken:AppToken,
        editType:ListID?"Name":"",postId:ListID?ListID:"",menuOrder:(itemArr?.length+1)}));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){
    
           console.log(response)
          if(response?.BookmarkList){
        setResponseMessage(response?.message);
        setSnackbarColor("rgba(144, 202, 249,1)");
      
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
      
      // console.log(response?.BookmarkList)
      updateItemTitle(response?.BookmarkList?.ID,response?.BookmarkList?.Name)
      
      setNewListPopUp(false);
      setListName("");
      setListID("");
      setFolderMenuOrder("")
    
    },1000)
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
        
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }

      const handleAddFolderToList=(editTypeVal,parentEntityId)=>{
        setCheckedStatusOfList(parentEntityId,editTypeVal=="public"?true:false);
             
        setLoader({status:true});
        // console.log({
        //     token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",
        //     currentToken:currentToken?currentToken:"",appToken:AppToken,
        //     editType:editTypeVal,menuOrder:(itemArr?.length+1),parentEntityType:"List"
        //     ,childEntityType:"Folder",parentEntityId:parentEntityId,childEntityId:folderItem?.ID?folderItem?.ID:"",visibility:"public"})
          const apiData = dispatch(addFolderToListAPI({
            token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",appToken:AppToken,
            editType:editTypeVal,menuOrder:(itemArr?.length+1),parentEntityType:"List"
            ,childEntityType:"Folder",parentEntityId:parentEntityId,childEntityId:folderItem?.ID?folderItem?.ID:"",visibility:"public"}));
          /* get response as Promise   */
          apiData.then(response => {
            if(response){
        
              //  console.log(response)
             
              if(response){
            setResponseMessage(response?.message);
            setSnackbarColor("rgba(144, 202, 249,1)");
          
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
          
         
        },1000)
           }else{
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
           }
              
            
           if(response?.logout){
           
            setResponseMessage("You are Logged Out!!!");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            setTimeout(()=>{
              dispatch({type:"LOGOUT"});
        
            },3000)
            
          }
        /* resetting Login input Fields */
        
            }else{
              setResponseMessage("Something Went Wrong...");
              
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)    }
        
          }).catch(error => {
         
            //popup of error Info
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            console.error(error);
          });
         
          }
          const getAllListByFolderID=(itemAllArray)=>{

            setLoader({status:true});
            const apiData = dispatch(addFolderToListAPI({
              token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",
              currentToken:currentToken?currentToken:"",appToken:AppToken,
              editType:"getListsByFolderId",menuOrder:(itemArr?.length+1),parentEntityType:"List"
              ,childEntityType:"Folder",parentEntityId:"",childEntityId:folderItem?.ID?folderItem?.ID:"",visibility:"public"}));
            /* get response as Promise   */
            apiData.then(response => {
              if(response){
               
                const checkedIdArray = response?.lists.map(item => ({
                 
                  checkedID:item.ID,
                  checkedStatus:true
              }));
              
              // Filtering and adding matching objects to a new array
         
              // Create a new array without modifying the original
const modifiedArray = itemAllArray.map(item => {
  const match = checkedIdArray.find(checked => checked.checkedID === item.ID);
  return match ? { ...item, checkedStatus: match.checkedStatus } : { ...item };
});

             
              
setItemArr(modifiedArray?.length?modifiedArray:itemArr)
            
              }else{
                setResponseMessage("Something Went Wrong...");
                
                setSnackbarColor("#958FDA");
             
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)    }
          
            }).catch(error => {
           
              //popup of error Info
              setResponseMessage("Something Went Wrong...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              console.error(error);
            })
             
              }


              const getFoldersByListId=(parentEntityId,ListName)=>{

                setLoader({status:true});
                const apiData = dispatch(addFolderToListAPI({
                  token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",
                  currentToken:currentToken?currentToken:"",appToken:AppToken,
                  editType:"getFoldersInList",menuOrder:(itemArr?.length+1),parentEntityType:"List"
                  ,childEntityType:"Folder",parentEntityId:parentEntityId,childEntityId:"",visibility:"public"}));
                /* get response as Promise   */
                apiData.then(response => {
                  if(response){
                   
                   setFolders(response?.folders)
                   setOpenPopUp(true)
                   
                setLoader({status:false});
                setListName(ListName);
                  // Filtering and adding matching objects to a new array
             
                  // Create a new array without modifying the original
     
                  }else{
                    setResponseMessage("Something Went Wrong...");
                    
                    setSnackbarColor("#958FDA");
                 
                     
                setLoader({status:false});
                
                setSnackbarVisible(true);
                setTimeout(()=>{
                  
                  setSnackbarVisible(false);
                 
                   
                },3000)    }
              
                }).catch(error => {
               
                  //popup of error Info
                  setResponseMessage("Something Went Wrong...");
                    
                  setSnackbarColor("#958FDA");
               
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)
                  console.error(error);
                })
                 
                  }
    
    
  const flattenedData = itemArr!=[]?Object.values(itemArr):'';

        const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
        const foldersData = folders!=[]?Object.values(folders):null;

        


    return (<> {<Loading  Load={loader?.status}/>}
    {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
    
     <div  align="center" className="appDesignPopUpOpacity"> </div>
        <div  align="center" className="AreYouSurePopUp" style={{height:"400px",borderRadius: '20px'}}> 
<h2>Add Folder To  Bookmark List  </h2>
<h6>Bookmark List Can Have Folders From Different Courses!!!. Folders From Bookmark List Can Be Quickly Imported To Other Courses, Subcourses, Milestones etc. </h6>
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"220px",overflowX:"hidden"}}>
{flattenedData?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.ID} >
<div  className="courseContentItemOuter">
      {/* <Checkbox onchange={()=>{ }} name=""value="" type="checkbox" status=""title=""card="checkbox" /> */}
    
      <label onMouseEnter={
                            ()=>handleMouseEnter("#fff","#333","")}
             onMouseLeave={handleMouseLeave} className={"checkbox-outer"}>
                  {
                  // iterate map 
                  }         
             <input type="checkbox" title="Set As Days" checked={item?.checkedStatus?item?.checkedStatus:false}  
  className="input-textbox"  value="days"  name="courseExpiryType1"  
  onChange={event=>{
    // set value as folderId , send folder Id  over api if checked and action as Add  , If unchecked - action as remove
    // alert(e.target.value); // set status of list to lists array dynamically
    setActive({...active,status:!active?.status}); 
    event.target.checked?handleAddFolderToList("public",item?.ID):handleAddFolderToList("trash",item?.ID) 
    }}/>
       <span class={"square"}></span> </label>  <div align="left" className="themeNone TitleWithEllipsis"
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {item?.Name}
      </div>
<div className="gridAppFiftyAll" style={{alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><Pencil onClick={()=>{setListName(item?.Name);
  setListID(item?.ID);setNewListPopUp(true)}}
     onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
     color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/><Blocks 
      onClick={()=>{getFoldersByListId(item?.ID,item?.Name)}}  onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
  color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>
      </div>
      </div>
</div>)) :""}



{flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={index} 
          >
<div  className="courseContentItemOuterHeadActiveSettings" style={{marginTop:"0px",paddingLeft:"10px",background:"#f1f1f1"}}>
<div className="courseContentItemJustifyContentIcons"> <div 
 color="#666666" style={{padding:"4px",width:"20px",background:"#ffffff",borderRadius:"5px",cursor:"pointer",}}/> 

<div></div></div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
 
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInn"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  <div 
 color="#666666" style={{padding:"4px",marginLeft:"5px",width:"20px",background:"#",borderRadius:"5px",cursor:"pointer",}}/> 
<div 
 color="#666666" style={{padding:"4px",marginLeft:"5px",width:"20px",background:"#",borderRadius:"5px",cursor:"pointer"}}/> <div 
 color="#666666" style={{padding:"4px",marginLeft:"5px",width:"20px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/> <div 
 color="#666666" style={{padding:"4px",marginLeft:"5px",width:"20px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>  </div>
  {/* <ChevronUp  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/>  */}
  </div>  </div>)) }
</div>
<div align="center" className="" style={{display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{closePopUp()}}   className=" CoursesPreviewTopBtn"  type="submit"
 > Close </button>

<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setNewListPopUp(true);setListName("");
    setListID("")}}  style={{background:"rgba(144, 202, 249,1)",color:"#fff"}}
  className=" CoursesPreviewTopBtn"  type="submit"
 > + New List</button>
</div> 
{newListPopUp?<div className="selectThumbImgOuterAllSelected"  style={{zIndex:9999} }>
   <div  className="CreateNewEntity" style={{zIndex:9999} }>
    
        <div align="center">
        <h1 style={{"textAlign":"center",marginTop:"10px",
       
      }}> {!ListID?"Create New":"Update"}   <span className="coloredTextV1" >LIST</span> {!ListID?"":"Name"}  </h1>

<div align="center" className="">
    
    
    
<textarea onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} className="createContentTextbox"  style= {{fontSize:"24px",width:"85%"}} 
    placeholder="Add List Name" type="text"
 rows={8} name="courseTitle" value={listName} onChange={
    (e)=>setListName(e.target.value)


 } />
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"0px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setNewListPopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
 > Cancel </button>

{!ListID?<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateList()}}  style={{background:"rgba(144, 202, 249,1)",color:"#fff"}}
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"...":"Click To  Create"} </button>:
 <button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleUpdateList()}}  style={{background:"rgba(144, 202, 249,1)",color:"#fff"}}
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"...":"Update"} </button>}
</div>  </div></div></div></div>:""}



{openPopUp?<div className="selectThumbImgOuterAll"  style={{zIndex:99999}}>
   
 
   <div  className="ShowFoldersDoubleOuter" style={{zIndex:999999}}>
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",float:"right",margin:"10px",
      background:"#958FDA",zIndex:999999}} onClick={()=>setOpenPopUp(false)}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
        <h3>Showing All Folders In List  {listName?"- "+listName:""}</h3>
<div  className="ShowFoldersOuterContainer" style={{} }>
    {folders?.length?foldersData.map((item,index)=>
     <div align="center"
              style={{
             padding:"10px"
             
              
            }}  
          
            >
<div  className="" style={{marginTop:"0px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}>
<div className="">
<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"70px",
    
   }}/><div className="themeNone TitleWithEllipsis"
   style={{fontSize:"25px",color:"#111",fontWeight:"700",width:"140px"}}> 
    {item?.Name}
   
    </div> </div></div></div>
   ): <div align="center"style={{margin:"15px",height:"140px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
      }}> Opps... <span className="coloredTextV1">No Folders Found In This List!!!</span> Keep Adding Any Folder To Lists .  </h3>
      <h5>Bookmark List Can Have Folders From Different Courses!!!. Folders From Bookmark List Can Be Quickly
         Imported To Other Courses, Subcourses, Milestones, Sections or Even Chapters. So This Is A Best Practice To Save Them For Later. </h5>
      </div>}
   
   </div>
   </div>
   
   </div>:""}
</div>
   
<div>
   
   </div> 
 
   
   
     </>)
}
export default BookmarkListPopUp;

